import React from 'react';
import ArticleIcon from '../../assets/ArticleIcon';
import ArticleIconWhite from '../../assets/ArticleIconWhite';
// import AudioIcon from '../../assets/AudioIcon';
// import AudioIconWhite from '../../assets/AudioIconWhite';
import BlogIcon from '../../assets/BlogIcon';
import BlogIconWhite from '../../assets/BlogIconWhite';
import VideoIcon from '../../assets/VideoIcon';
import VideoIconWhite from '../../assets/VideoIconWhite';

export const buttons = [
  {
    name: 'Video',
    icon: <VideoIcon />,
    whiteIcon: <VideoIconWhite />,
  },
  // {
  //   name: 'Audio',
  //   icon: <AudioIcon />,
  //   whiteIcon: <AudioIconWhite />,
  // },
  {
    name: 'Article',
    icon: <ArticleIcon />,
    whiteIcon: <ArticleIconWhite />,
  },
  {
    name: 'Blog',
    icon: <BlogIcon />,
    whiteIcon: <BlogIconWhite />,
  },
];
